export class GetCategoryRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  active: string | null = '';
}

export class CreateCategoryParams {
  name: string = '';
  active: string = '';
}

export interface CategoryData {
  id: string;
  code: string;
  name: string;
  active: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string;
}

export interface GetCategoryResponse {
  code: number;
  message: string;
  data: CategoryData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetCategoryByIdResponse {
  code: number;
  message: string;
  data: CategoryData;
}
